(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artstation-1824-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-hsea2-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.hsea2-points__media');
        const video = media ? media.querySelector('video') : null;

        if (!video) return;

        const updateState = () => {
          const isPaused = video.paused;

          button.classList.toggle('is-paused', isPaused);
          button.setAttribute(
            'aria-label',
            isPaused ? '영상 재생' : '영상 일시정지'
          );
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);

        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeVideos(),
        { once: true }
      );
    } else {
      initializeVideos();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initializeVideos(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artstation-2436-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-hsea2-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.hsea2-points__media');
        const video = media ? media.querySelector('video') : null;

        if (!video) return;

        const updateState = () => {
          button.classList.toggle('is-paused', video.paused);
          button.setAttribute(
            'aria-label',
            video.paused ? '영상 재생' : '영상 일시정지'
          );
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);

        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeVideos(),
        { once: true }
      );
    } else {
      initializeVideos();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initializeVideos(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flowing-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uuna-faq-wall'))customElements.define('uuna-faq-wall',class extends HTMLElement{
 connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;this.querySelector('.fq-toggle')?.addEventListener('click',e=>{const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.textContent=paused?e.currentTarget.dataset.resume:e.currentTarget.dataset.pause},{signal});this.addEventListener('shopify:block:select',()=>{this.dataset.paused='true';const b=this.querySelector('.fq-toggle');if(b){b.textContent=b.dataset.resume;b.setAttribute('aria-pressed','true')}},{signal})}
 disconnectedCallback(){this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iauto-standard-advanced-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-iauto-sa-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.iauto-sa-points__media');
        const video = media ? media.querySelector('video') : null;

        if (!video) return;

        const updateState = () => {
          const isPaused = video.paused;

          button.classList.toggle('is-paused', isPaused);

          button.setAttribute(
            'aria-label',
            isPaused ? '영상 재생' : '영상 일시정지'
          );
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);

        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeVideos(),
        { once: true }
      );
    } else {
      initializeVideos();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initializeVideos(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idraw-20-a4-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-idraw20-a4-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.idraw20-a4-points__media');
        const video = media ? media.querySelector('video') : null;
        if (!video) return;

        const updateState = () => {
          const isPaused = video.paused;
          button.classList.toggle('is-paused', isPaused);
          button.setAttribute('aria-label', isPaused ? '영상 재생' : '영상 일시정지');
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);
        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeVideos(), { once: true });
    } else {
      initializeVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idraw-h-a0-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-ha0-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.ha0-points__media');
        const video = media ? media.querySelector('video') : null;
        if (!video) return;

        const updateState = () => {
          const isPaused = video.paused;
          button.classList.toggle('is-paused', isPaused);
          button.setAttribute('aria-label', isPaused ? '영상 재생' : '영상 일시정지');
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);
        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeVideos(), { once: true });
    } else {
      initializeVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idraw-h-a1-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-ha1-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.ha1-points__media');
        const video = media ? media.querySelector('video') : null;
        if (!video) return;

        const updateState = () => {
          const isPaused = video.paused;
          button.classList.toggle('is-paused', isPaused);
          button.setAttribute('aria-label', isPaused ? '영상 재생' : '영상 일시정지');
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);
        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeVideos(), { once: true });
    } else {
      initializeVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idraw-h-a2-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-ha2-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.ha2-points__media');
        const video = media ? media.querySelector('video') : null;
        if (!video) return;

        const updateState = () => {
          const isPaused = video.paused;
          button.classList.toggle('is-paused', isPaused);
          button.setAttribute('aria-label', isPaused ? '영상 재생' : '영상 일시정지');
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);
        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeVideos(), { once: true });
    } else {
      initializeVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idraw-h-se-a2-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root
        .querySelectorAll('[data-hsea2-video-toggle]')
        .forEach((button) => {
          if (button.dataset.initialized === 'true') return;

          const media = button.closest(
            '.hsea2-points__media'
          );

          const video = media
            ? media.querySelector('video')
            : null;

          if (!video) return;

          const updateState = () => {
            const isPaused = video.paused;

            button.classList.toggle(
              'is-paused',
              isPaused
            );

            button.setAttribute(
              'aria-label',
              isPaused
                ? '영상 재생'
                : '영상 일시정지'
            );
          };

          button.dataset.initialized = 'true';

          button.addEventListener('click', () => {
            if (video.paused) {
              video.play().catch(updateState);
            } else {
              video.pause();
            }
          });

          video.addEventListener(
            'play',
            updateState
          );

          video.addEventListener(
            'pause',
            updateState
          );

          updateState();
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeVideos(),
        { once: true }
      );
    } else {
      initializeVideos();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initializeVideos(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-stream-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('uuna-stream-expand')) {
  customElements.define('uuna-stream-expand', class extends HTMLElement {
    connectedCallback() {
      if(this.controller) return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.reveal=this.querySelector('[data-reveal]');
      this.features=[...this.querySelectorAll('[data-feature]')];
      this.setupStream();
      const schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};
      this.schedule=schedule;
      window.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('resize',schedule,{passive:true,signal});
      this.motion.addEventListener('change',schedule,{signal});
      document.addEventListener('visibilitychange',schedule,{signal});
      this.addEventListener('shopify:block:select',()=>{this.editorSelected=true;this.update()},{signal});
      this.addEventListener('shopify:block:deselect',()=>{this.editorSelected=false;this.update()},{signal});
      this.resize=new ResizeObserver(schedule);this.resize.observe(this);
      this.update();
    }
    update(){
      const vh=window.innerHeight;
      const rect=this.getBoundingClientRect();
      this.toggleAttribute('data-stream-paused',document.hidden||rect.bottom<0||rect.top>vh||this.motion.matches);
      this.classList.toggle('image-stream-hero--reduced-motion',this.motion.matches);
      const enabled=this.dataset.expandEnabled!=='false'&&!this.motion.matches&&!this.editorSelected;
      this.classList.toggle('ish-enhanced',enabled);
      const clamp=n=>Math.max(0,Math.min(1,n));
      const progress=enabled?clamp((vh*.94-this.reveal.getBoundingClientRect().top)/(vh*.65)):1;
      this.style.setProperty('--ish-progress',progress.toFixed(4));
      this.features.forEach(el=>{
        const p=enabled?clamp((vh*.98-el.getBoundingClientRect().top)/(vh*.25)):1;
        el.style.setProperty('--feature-opacity',String(.35+.65*p));
        el.style.setProperty('--feature-y',((1-p)*20).toFixed(2)+'px');
      });
    }
    disconnectedCallback(){
      this.controller?.abort();this.controller=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;
      this.generatedStyle?.remove();this.querySelectorAll('[data-stream-rail]').forEach(el=>el.replaceChildren());
    }
    setupStream(){
      const root=this;
      const imagesElement = root.querySelector('[data-stream-images]');
      const rails = Array.from(
        root.querySelectorAll('[data-stream-rail]')
      );
      const corridor = root.querySelector('[data-stream-corridor]');

      if (!imagesElement || !corridor || rails.length === 0) {
        return;
      }

      let images = [];

      try {
        images = JSON.parse(
          imagesElement.textContent || '[]'
        ).filter((image) => image.src);
      } catch (error) {
        images = [];
      }

      if (images.length === 0) {
        return;
      }

      const getNumber = (name, fallback) => {
        const value = Number(root.dataset[name]);

        return Number.isFinite(value) ? value : fallback;
      };

      const settings = {
        cards: Math.max(
          3,
          Math.round(getNumber('cards', 9))
        ),
        speed: Math.max(
          4,
          getNumber('speed', 18)
        ),
        axis: getNumber('axis', 55),
        perspective: getNumber('perspective', 30),
        cardWidth: getNumber('cardWidth', 18),
        cardHeight: getNumber('cardHeight', 25),
        cardRadius: getNumber('cardRadius', 0.8),
        birthHeight: getNumber('birthHeight', 2.6),
        exitHeight: getNumber('exitHeight', 46),
        railBirth: getNumber('railBirth', -11),
        railExit: getNumber('railExit', 44),
        fan: getNumber('fan', 3.3),
        turnBirth: getNumber('turnBirth', 6),
        turnExit: getNumber('turnExit', 28),
        stops: 24
      };

      corridor.style.perspective =
        `${settings.perspective}cqw`;

      corridor.style.perspectiveOrigin =
        `50% ${settings.axis}%`;

      const instanceId = root.id.replace(
        /[^a-zA-Z0-9]/g,
        ''
      );

      const createKeyframes = (direction, name) => {
        const frames = [];

        for (
          let step = 0;
          step <= settings.stops;
          step += 1
        ) {
          const progress = step / settings.stops;

          const scale =
            (settings.birthHeight / settings.cardHeight) *
            Math.pow(
              settings.exitHeight /
              settings.birthHeight,
              progress
            );

          const z =
            settings.perspective *
            (1 - 1 / scale);

          const rail =
            settings.railExit -
            (
              settings.railExit -
              settings.railBirth
            ) *
            Math.pow(
              1 - progress,
              settings.fan
            );

          const turn =
            settings.turnBirth +
            (
              settings.turnExit -
              settings.turnBirth
            ) *
            progress;

          frames.push(
            `${(progress * 100).toFixed(2)}%{transform:translate3d(${(
              direction * rail
            ).toFixed(2)}cqw,0,${z.toFixed(
              2
            )}cqw) rotateY(${(
              -direction * turn
            ).toFixed(2)}deg)}`
          );
        }

        return `@keyframes ${name}{${frames.join('')}}`;
      };

      const style = document.createElement('style');

      const rightAnimation =
        `image-stream-right-${instanceId}`;

      const leftAnimation =
        `image-stream-left-${instanceId}`;

      style.textContent =
        createKeyframes(
          1,
          rightAnimation
        ) +
        createKeyframes(
          -1,
          leftAnimation
        );

      root.appendChild(style);
      this.generatedStyle = style;

      rails.forEach((rail, railIndex) => {
        const direction =
          railIndex === 0 ? 1 : -1;

        const animationName =
          direction === 1
            ? rightAnimation
            : leftAnimation;

        for (
          let index = 0;
          index < settings.cards;
          index += 1
        ) {
          const image =
            images[index % images.length];

          const card =
            document.createElement('div');

          const imageElement =
            document.createElement('img');

          card.className =
            'image-stream-hero__card';

          card.style.left = '50%';
          card.style.top =
            `${settings.axis}%`;

          card.style.width =
            `${settings.cardWidth}cqw`;

          card.style.height =
            `${settings.cardHeight}cqw`;

          card.style.marginLeft =
            `${-settings.cardWidth / 2}cqw`;

          card.style.marginTop =
            `${-settings.cardHeight / 2}cqw`;

          card.style.borderRadius =
            `${settings.cardRadius}cqw`;

          card.style.animationName =
            animationName;

          card.style.animationDuration =
            `${settings.speed}s`;

          card.style.animationDelay =
            `${-(index * settings.speed) / settings.cards}s`;

          card.style.backfaceVisibility =
            'hidden';

          imageElement.src = image.src;
          imageElement.alt = '';
          imageElement.loading = 'lazy';
          imageElement.decoding = 'async';
          imageElement.draggable = false;

          card.appendChild(imageElement);
          rail.appendChild(card);
        }
      });

      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        root.classList.add(
          'image-stream-hero--reduced-motion'
        );
      }

    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uuna-3-a0-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeA0Videos = (root = document) => {
      root
        .querySelectorAll('[data-uuna3a0-video-toggle]')
        .forEach((button) => {
          if (button.dataset.initialized === 'true') return;

          const media = button.closest('.uuna3a0-points__media');
          const video = media ? media.querySelector('video') : null;

          if (!video) return;

          const updateState = () => {
            button.classList.toggle('is-paused', video.paused);
            button.setAttribute(
              'aria-label',
              video.paused ? '영상 재생' : '영상 일시정지'
            );
          };

          button.dataset.initialized = 'true';

          button.addEventListener('click', () => {
            if (video.paused) {
              video.play().catch(updateState);
            } else {
              video.pause();
            }
          });

          video.addEventListener('play', updateState);
          video.addEventListener('pause', updateState);

          updateState();
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeA0Videos(),
        { once: true }
      );
    } else {
      initializeA0Videos();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initializeA0Videos(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uuna-3-a1-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root.querySelectorAll('[data-hsea2-video-toggle]').forEach((button) => {
        if (button.dataset.initialized === 'true') return;

        const media = button.closest('.hsea2-points__media');
        const video = media ? media.querySelector('video') : null;

        if (!video) return;

        const updateState = () => {
          const isPaused = video.paused;

          button.classList.toggle('is-paused', isPaused);
          button.setAttribute(
            'aria-label',
            isPaused ? '영상 재생' : '영상 일시정지'
          );
        };

        button.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(updateState);
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', updateState);
        video.addEventListener('pause', updateState);

        updateState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeVideos(),
        { once: true }
      );
    } else {
      initializeVideos();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initializeVideos(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uuna-art-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uuna-floating-hero')) {
    customElements.define('uuna-floating-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const button = this.querySelector('.ufh__motion');
        if (!button) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? button.dataset.resume : button.dataset.pause;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uuna-tek-30-a3-key-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideos = (root = document) => {
      root
        .querySelectorAll('[data-uuna30-a3-video-toggle]')
        .forEach((button) => {
          if (button.dataset.initialized === 'true') return;

          const media = button.closest(
            '.uuna30-a3-points__media'
          );

          const video = media
            ? media.querySelector('video')
            : null;

          if (!video) return;

          const updateState = () => {
            const isPaused = video.paused;

            button.classList.toggle(
              'is-paused',
              isPaused
            );

            button.setAttribute(
              'aria-label',
              isPaused ? '영상 재생' : '영상 일시정지'
            );
          };

          button.dataset.initialized = 'true';

          button.addEventListener('click', () => {
            if (video.paused) {
              video.play().catch(updateState);
            } else {
              video.pause();
            }
          });

          video.addEventListener('play', updateState);
          video.addEventListener('pause', updateState);

          updateState();
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeVideos(),
        { once: true }
      );
    } else {
      initializeVideos();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initializeVideos(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
